<template>
  <div
    v-if="isGetConfig"
    class="home-page"
    :style="[backgroundImage, themeStyle]"
  >
    <div
      v-if="!configData.base.background.image"
      class="header-default-background"
    >
      <picture>
        <source
          :srcset="require('@/assets/images/items/image.webp')"
          type="image/webp"
        >
        <b-img
          :src="require('@/assets/images/items/image.png')"
          height="100"
          alt="背景圖片"
          class="d-block d-sm-none mt-2"
        />
      </picture>
      <div class="text-center mt-2">
        電腦版
        <br>
        建議：1920X600
        <br>
        最小：1024X400
        <br>
        手機版
        <br>
        建議：1200X1920
        <br>
        最小：400X650
      </div>
    </div>
    <template-header
      ref="header"
      :config-data="configData"
    />

    <div ref="content">
      <b-container
        id="container-1"
        class="container-1"
      >
        <div
          v-if="configData.area1.buttons.length > 0"
          class="area-1"
          :style="area1Style"
        >
          <template-button
            v-for="btn, index in configData.area1.buttons"
            :key="index"
            :btn-config="btn"
            :default-width="'25%'"
          />
        </div>
        <template-empty-area
          v-else
          :area-name="'板塊(一)'"
        />
      </b-container>
      <b-container class="container-2">
        <b-row>
          <b-col
            cols="12"
            lg="9"
          >
            <template-news :config-data="configData" />
          </b-col>
          <b-col
            cols="12"
            lg="3"
          >
            <!-- class="d-flex align-items-center justify-content-center" -->
            <template-side :config-data="configData" />
          </b-col>

        </b-row>
      </b-container>
      <b-container class="container-3">
        <div
          v-if="configData.area5.buttons.length > 0"
          class="area-5"
          :style="area5Style"
        >
          <template-button
            v-for="btn, index in configData.area5.buttons"
            :key="index"
            :btn-config="btn"
            :default-width="'300px'"
          />
        </div>
        <template-empty-area
          v-else
          :area-name="'板塊(五)'"
        />
      </b-container>
    </div>

    <template-footer
      ref="footer"
      :config-data="configData.footer"
      :ad-data="adConfig"
    />
    <template-go-top :config-data="configData.footer.gotop" />
    <pop-up-ads
      :config-data="configData.base.popup"
    />
    <search-view
      :theme-style="configData.base.config"
      :footer-display="footerDisplay"
    />

    <div
      v-if="configData.base.advertise && configData.base.advertise.show"
      class="advertise left d-none d-md-block"
    >
      <div class="close-btn">
        <button @click="configData.base.advertise.show = false">
          <svg
            clip-rule="evenodd"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m21 3.998c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm7.491 6.432 2.717-2.718c.146-.146.338-.219.53-.219.404 0 .751.325.751.75 0 .193-.073.384-.22.531l-2.717 2.717 2.728 2.728c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-2.728-2.728-2.728 2.728c-.147.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l2.728-2.728-2.722-2.722c-.146-.147-.219-.338-.219-.531 0-.425.346-.749.75-.749.192 0 .384.073.53.219z"
              fill-rule="nonzero"
            />
          </svg>
          關閉
        </button>
      </div>
      <template-button
        :btn-config="configData.base.advertise"
        :default-height="'300px'"
        :default-width="'200px'"
      />
    </div>

    <div
      v-if="configData.base.advertise2 && configData.base.advertise2.show"
      class="advertise right d-none d-md-block"
    >
      <div class="close-btn">
        <button @click="configData.base.advertise2.show = false">
          <svg
            clip-rule="evenodd"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m21 3.998c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm7.491 6.432 2.717-2.718c.146-.146.338-.219.53-.219.404 0 .751.325.751.75 0 .193-.073.384-.22.531l-2.717 2.717 2.728 2.728c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-2.728-2.728-2.728 2.728c-.147.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l2.728-2.728-2.722-2.722c-.146-.147-.219-.338-.219-.531 0-.425.346-.749.75-.749.192 0 .384.073.53.219z"
              fill-rule="nonzero"
            />
          </svg>
          關閉
        </button>
      </div>
      <template-button
        :btn-config="configData.base.advertise2"
        :default-height="'300px'"
        :default-width="'200px'"
      />
    </div>

    <copy-right v-if="isGetConfig && footerDisplay" />
  </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BContainer, BRow, BCol, BImg,
} from 'bootstrap-vue'
import TemplateHeader from './TemplateHeader.vue'
import TemplateNews from './TemplateNews.vue'
import TemplateSide from './TemplateSide.vue'

import TemplateFooter from '../component/TemplateFooter.vue'
import TemplateButton from '../component/TemplateButton.vue'
// import TemplateButtonList from '../component/TemplateButtonList.vue'
import TemplateEmptyArea from '../component/TemplateEmptyArea.vue'
import TemplateGoTop from '../component/TemplateGoTop.vue'
import searchView from '../component/SearchView.vue'
import PopUpAds from '../component/PopUpAds.vue'
import CopyRight from '../component/CopyRightFooter.vue'

import store from '@/store'
import useStoreModule from './useStoreModule'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BImg,
    TemplateHeader,
    TemplateFooter,
    TemplateNews,
    TemplateSide,
    TemplateButton,
    // TemplateButtonList,
    TemplateEmptyArea,
    TemplateGoTop,
    searchView,
    PopUpAds,
    CopyRight,
  },
  data() {
    return {
      backgroundImage: null,
      themeStyle: null,
      area1Style: null,
      area5Style: null,
    }
  },
  computed: {
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  watch: {
    isGetConfig(value) {
      if (value) {
        document.title = this.serverName ? this.serverName : document.title
        this.handleResize()
        this.themeStyle = this.configData.base.config
        this.area1Style = this.configData.area1.config
        this.area5Style = this.configData.area5.config
      }
    },
  },
  mounted() {
  },
  created() {
    // 在组件创建时添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件销毁之前移除事件监听器，以防止内存泄漏
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    handleResize() {
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      this.themeStyle = JSON.parse(JSON.stringify(this.configData.base.config))
      this.backgroundImage = {}
      if (this.configData.base.background && this.configData.base.background.image) this.backgroundImage.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.base.background.image) : this.configData.base.background.image})`
      if (windowWidth < 991 && this.configData.base.backgroundsm && this.configData.base.backgroundsm.image) {
        this.backgroundImage.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.base.backgroundsm.image) : this.configData.base.backgroundsm.image})`
      }
      this.$nextTick(() => {
        const headerHeight = this.$refs.header.$el.clientHeight
        const contentHeight = this.$refs.content.clientHeight
        const footerHeight = this.$refs.footer.$el.clientHeight
        const windowSpace = windowHeight - (headerHeight + footerHeight + contentHeight)
        if (windowSpace > 0) {
          this.$refs.footer.$el.style.marginTop = `${windowSpace}px`
        } else {
          this.$refs.footer.$el.style.marginTop = 0
        }
      })
    },
  },
  setup() {
    // 模組註冊
    const HOME_ADMIN_STORE_MODULE_NAME = 'template'

    if (!store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.registerModule(HOME_ADMIN_STORE_MODULE_NAME, useStoreModule)

    onUnmounted(() => {
      if (store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.unregisterModule(HOME_ADMIN_STORE_MODULE_NAME)
    })

    const isGetConfig = ref(false)
    const configData = ref(null)
    const adConfig = ref(null)
    const classData = ref(null)
    const serverName = ref('')
    const baseUrl = ref('')
    const footerDisplay = ref(true)

    const getAdConfig = () => {
      store.dispatch('template/getAdConfig')
        .then(localResponse => {
          adConfig.value = localResponse.data
        })
    }

    const getLocalConfig = () => {
      store.dispatch('template/getLocalConfig')
        .then(localResponse => {
          configData.value = localResponse.data
          isGetConfig.value = true
        })
    }

    const getHomeConfig = () => {
      store.dispatch('template/getHomeConfig')
        .then(response => {
          if (!response.data.success) {
            getLocalConfig()
            return
          }
          configData.value = response.data.data.data
          baseUrl.value = response.data.data.base_url
          classData.value = response.data.data.class_data
          serverName.value = response.data.data.server_name
          if (response.data.data.support_url) store.dispatch('api/loadTawkToScript', response.data.data.support_url)
          if (response.data.data.footer_display !== undefined && response.data.data.footer_display === false) footerDisplay.value = false
          store.commit('api/UPDATE_SERVER_NAME', serverName.value)
          store.commit('api/UPDATE_CLASS_DATA', classData.value)
          store.commit('api/UPDATE_BASE_URL', baseUrl.value)
          if (configData.value) isGetConfig.value = true
          else getLocalConfig()
        })
        .catch(() => {
          getLocalConfig()
        })
    }
    getAdConfig()
    getHomeConfig()
    return {
      serverName,
      footerDisplay,
      baseUrl,
      adConfig,
      configData,
      isGetConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
$background-color: var(--background-color);
$background-style: var(--background-style);
$background-style-sm: var(--background-style-sm);
$background-attachment: var(--background-attachment);
$background-attachment-sm: var(--background-attachment-sm);
$text-color: var(-text-color);
.home-page {
  position: relative;
  background-repeat: no-repeat;
  background-position: top;
  background-size: $background-style;
  background-attachment: $background-attachment;
  background-color: $background-color;
  min-height: 100vh;
  @media screen and (max-width: 991px) {
    background-size: $background-style-sm;
    background-attachment: $background-attachment-sm;
  }
}
.header-default-background {
  position: absolute;
  top: 0;
  z-index: -1;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 3px dashed #1d1d1d;
  border-radius: 10px;
  box-shadow: 0 0 0 2px #fff;
  background-color: #FCF7EE;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.container-1 {
  min-height: 100px;
  margin-bottom: 1rem;
  // @media screen and (min-width: 1200px) {
  //   max-width: 1400px;
  // }
}
.container-2 {
  min-height: 500px;
  // @media screen and (min-width: 1200px) {
  //   max-width: 1400px;
  // }
}
.container-3 {
  margin-bottom: 2rem;
  // @media screen and (min-width: 1200px) {
  //   max-width: 1400px;
  // }
}
.area-1 {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--padding);
  margin: var(--margin);
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
}
.area-5 {
  display: flex;
  flex-direction: column;
  padding: var(--padding);
  margin: var(--margin);
}

// .advertise {
//   position: fixed;
//   z-index: 100;
//   bottom: 10px;
//   left: 0;
//   &.left {
//     left: 0;
//     .close-btn{
//       justify-content: start;
//     }
//   }
//   &.right {
//     right: 0;
//     .close-btn{
//       justify-content: flex-end;
//     }
//   }
//   .close-btn {
//     display: flex;
//     justify-content: flex-start;
//     button {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       font-size: 12px;
//       color: $text-color;
//       border: none;
//       background-color: transparent;
//       transition: .3s;
//       &:hover {
//         transform: scale(1.2);
//       }
//     }
//     svg {
//       fill: $text-color;
//       width: 16px;
//       height: 16px;
//     }
//   }
// }

.advertise {
  position: fixed;
  z-index: 100;
  bottom: 10px;
  &.left {
    left: 0;
    .close-btn{
      justify-content: start;
    }
  }
  &.right {
    right: 0;
    .close-btn{
      justify-content: flex-end;
    }
  }
  .close-btn {
    display: flex;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #fff;
      border: none;
      background-color: transparent;
      transition: .3s;
      &:hover {
        transform: scale(1.2);
      }
    }
    svg {
      fill: #fff;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
<!-- RWD自訂按鈕格式 -->
<style lang="scss">
.area-1 .btn-area{
  img {
    max-height: 240px;
  }
  @media screen and (max-width: 767px) {
    width: 50%;
    img {
      max-height: 180px;
    }
  }
  @media screen and (max-width: 575px) {
    img {
      max-height: 120px;
    }
  }
}
.area-2 .btn-area{
  width: 33.333%;
  @media screen and (max-width: 767px) {
    width: 50%;
  }
}
.area-3 .btn-area{
  img {
    max-height: 250px;
  }
  width: 100%;
  @media screen and (max-width: 991px) {
    img {
      max-height: 250px;
    }
  }
  @media screen and (max-width: 575px) {
    // width: 50%;
    // img {
    //   max-height: none;
    // }
  }
}
.area-4 .btn-area{
  img {
    max-height: 250px;
  }
  width: 100%;
  @media screen and (max-width: 991px) {
    img {
      max-height: 250px;
    }
  }
}
.area-5 .btn-area {
  img {
    max-height: 150px;
  }
}
</style>
